export default "__VITE_ASSET__0ba673df__"